module.exports = __webpack_public_path__ + "static/media/PMIUA.48fa0654.jpg";